<div class="container">
  <div class="model">
    <div class="model__txt">
      <h2 [innerHTML]="data.content_title"></h2>
      <p [innerHTML]="data.content_text"></p>
    </div>
    <div class="model__carousel">
      <ngx-slick-carousel class="carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let item of data.content_cards; let i = index" class="slide">
          <div class="slide__card">
            <div class="slide__card__img">
              <img [src]="item.image?.url || icons[i % icons.length]" alt="" />
            </div>
            <div class="slide__card__text">
              <p [innerHTML]="item.text"></p>
            </div>
            <div class="slide__card__line"></div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
